import pdfMake, { PlPreview } from "./pdfMake";
import type { TDocumentDefinitions } from "pdfmake/interfaces";

export function generatePlPdf(preview: PlPreview): void {
  const docDefinition: TDocumentDefinitions = {
    content: [
      { text: "Profit & Loss Statement", style: "header" },
      {
        text: `Period: ${preview.periodFrom} → ${preview.periodTo}`,
        margin: [0, 0, 0, 10],
      },

      {
        table: {
          widths: ["*", "auto"],
          body: [
            ["Total Income", preview.totalIncome.toLocaleString()],
            ["Total Expenditure", preview.totalExpenditure.toLocaleString()],
            ["Net Profit", preview.netProfit.toLocaleString()],
            ["Gross Margin", preview.grossProfitMargin],
          ],
        },
      },

      { text: "", margin: [0, 10] },

      { text: "Income Breakdown", style: "subheader" },

      {
        table: {
          widths: ["*", "auto"],
          body: [
            ["Category", "Amount"],
            ...preview.income.map((row) => [
              row.categoryName,
              (row.totalIncome ?? 0).toLocaleString(),
            ]),
          ],
        },
      },

      { text: "", margin: [0, 10] },

      { text: "Expenditure Breakdown", style: "subheader" },

      {
        table: {
          widths: ["*", "auto"],
          body: [
            ["Category", "Amount"],
            ...preview.expenditure.map((row) => [
              row.categoryName,
              (row.totalExpenditure ?? 0).toLocaleString(),
            ]),
          ],
        },
      },
    ],

    styles: {
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 10],
      },
      subheader: {
        fontSize: 14,
        bold: true,
        margin: [0, 10, 0, 5],
      },
    },
  };

  pdfMake
    .createPdf(docDefinition)
    .download(`PL_Report_${preview.periodFrom}_${preview.periodTo}.pdf`);
}
